import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import InlineCommentsFocusedInlineCommentQuery, {
	type InlineCommentsFocusedInlineCommentQuery$data,
	type InlineCommentsFocusedInlineCommentQuery$variables,
} from './view-mode/__generated__/InlineCommentsFocusedInlineCommentQuery.graphql.ts';

export function preloadFocusedInlineComment(
	commentId: string,
	contentId: string,
): Promise<{
	data: InlineCommentsFocusedInlineCommentQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<
		InlineCommentsFocusedInlineCommentQuery$data,
		InlineCommentsFocusedInlineCommentQuery$variables
	>({
		query: InlineCommentsFocusedInlineCommentQuery,
		variables: {
			commentId,
			contentId,
		},
	});
}
